export default "__VITE_ASSET__6dYzoEeA__"